import {
  AppointmentRemoteDataSource,
  AuthRemoteDataSource,
  BlogPostRemoteDataSource,
  ChatRemoteDataSource,
  CouponRemoteDataSource,
  NotificationRemoteDataSource,
  PamiaChatRemoteDataSource,
  PartnershipRemoteDataSource,
  PaymentRemoteDataSource,
  RatingRemoteDataSource,
  ScheduleRemoteDataSource,
  SettingsRemoteDataSource,
  SharedAppointmentSlotRemoteDataSource,
  UserRemoteDataSource,
} from "@phurshell/psiapp-frontend-core/data";
import { api } from "./api";

export const authDataSource = new AuthRemoteDataSource(api);
export const userDataSource = new UserRemoteDataSource(api);
export const appointmentDataSource = new AppointmentRemoteDataSource(api);
export const chatDataSource = new ChatRemoteDataSource(api);
export const paymentDataSource = new PaymentRemoteDataSource(api);
export const settingsDataSource = new SettingsRemoteDataSource(api);
export const scheduleDataSource = new ScheduleRemoteDataSource(api);
export const notificationDataSource = new NotificationRemoteDataSource(api);
export const ratingDataSource = new RatingRemoteDataSource(api);
export const couponDataSource = new CouponRemoteDataSource(api);
export const sharedAppointmentSlotDataSource =
  new SharedAppointmentSlotRemoteDataSource(api);
// exclusivos do paciente (não existem no pro)
export const partnershipDataSource = new PartnershipRemoteDataSource(api);
export const blogPostDataSource = new BlogPostRemoteDataSource(api);
export const pamiaChatDataSource = new PamiaChatRemoteDataSource(api);

// exclusivo do main: requisições que o core não cobre do mesmo jeito (ver app/datasources)
import { PatientAccountDataSource } from "@/app/datasources/PatientAccountDataSource";
import { PatientAppointmentDataSource } from "@/app/datasources/PatientAppointmentDataSource";
export const patientAccountDataSource = new PatientAccountDataSource(api);
export const patientAppointmentDataSource = new PatientAppointmentDataSource(api);
